import type { AccessApi } from '../api';

export async function deleteBindingAndReconcile(
  api: Pick<AccessApi, 'deleteBinding' | 'reconcile'>,
  bindingId: string,
  canRunReconcile = true,
): Promise<{ reconcileError?: unknown }> {
  await api.deleteBinding(bindingId);

  if (!canRunReconcile) {
    return {};
  }

  try {
    await api.reconcile({
      dryRun: false,
      bindingIds: [bindingId],
    });
  } catch (reconcileError) {
    return { reconcileError };
  }

  return {};
}
